import { Injectable, inject } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AccessControlService {
    private authService = inject(AuthService);

    /**
     * Gets the current user's role.
     */
    getCurrentUserRole(): string | null {
        const user = this.authService.user();
        return user ? user.role : null;
    }

    /**
     * Checks if the current user has the specified role.
     */
    hasRole(role: string): boolean {
        const userRole = this.getCurrentUserRole();
        return userRole === role;
    }

    /**
     * Checks if the current user has any of the specified roles.
     */
    hasAnyRole(roles: string[]): boolean {
        const userRole = this.getCurrentUserRole();
        if (!userRole) return false;
        return roles.includes(userRole);
    }

    /**
     * Returns true if the admin email restriction is disabled OR the current user
     * matches an entry in environment.authorizedAdmins where BOTH:
     *   1. email matches exactly (case-insensitive), AND
     *   2. the user's organization name contains orgName as a substring (case-insensitive).
     * Use this to guard menus/features that should only be visible to specific admins.
     */
    isAuthorizedAdmin(): boolean {
        if (!environment.enforceAdminEmailRestriction) return true;
        const user = this.authService.user();
        if (!user?.email) return false;
        const userEmail = user.email.toLowerCase();
        const userOrg = (user.organizationName ?? '').toLowerCase();
        return environment.authorizedAdmins.some(
            entry => userEmail === entry.email.toLowerCase()
                  && userOrg.includes(entry.orgName.toLowerCase())
        );
    }
}
